import { useState, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { makeDebounce } from 'components/Shared/FrictionlessLogin/debounce';
import SegmentIO from 'reporting/SegmentIO';
import { authActions } from 'store/auth/slice';

interface BlurredFields {
  email: boolean;
  phone: boolean;
  name: boolean;
}

export function useFormHandlers() {
  const dispatch = useDispatch();
  const [blurredFields, setBlurredFields] = useState<BlurredFields>({
    email: false,
    phone: false,
    name: false,
  });

  const handleBlur = useCallback((type: keyof BlurredFields) => {
    setBlurredFields((prev) => ({ ...prev, [type]: true }));
  }, []);

  const handleFocus = useCallback((type: keyof BlurredFields) => {
    if (type === 'email') {
      SegmentIO.frictionlessSubscriptionEmailFieldViewed();
    } else if (type === 'phone') {
      SegmentIO.frictionlessSubscriptionPhoneFieldViewed();
    }
  }, []);

  const debounceEmailSegment = useRef(makeDebounce());
  const debouncePhoneSegment = useRef(makeDebounce());

  const handleChange = useCallback(
    (value: string, type: keyof BlurredFields) => {
      if (type === 'email') {
        dispatch(authActions.setFrictionlessCheckoutEmail({ email: value }));
        debounceEmailSegment.current(() => {
          SegmentIO.frictionlessCheckoutEmailEdit();
        }, 1000);
      } else if (type === 'phone') {
        dispatch(authActions.setFrictionlessCheckoutPhone({ phone: value }));
        debouncePhoneSegment.current(() => {
          SegmentIO.frictionlessCheckoutPhoneEdit();
        }, 1000);
      }
    },
    [dispatch]
  );

  return {
    blurredFields,
    handleBlur,
    handleFocus,
    handleChange,
  };
}
